import styled from 'styled-components'

type ButtonProps = {
  height?: number
  width?: number
  backgroundColor?: string
  borderRadius?: number
  margin?: string
}

export const Button = styled.button<ButtonProps>`
  background-color: ${(props) =>
    props.backgroundColor ?? props.theme.success.feedback[400]};
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.height ? `${props.height}px` : '40px')};
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  color: white;
  border-radius: ${(props) => props.borderRadius ?? 4}px;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  margin: ${(props) => props.margin ?? 0};
`
